let _ß = {};

_ß.logic = {};

_ß.CLI = false;
_ß.DEBUG = false;
_ß.DEV = false;
_ß.MODE = 'production';
_ß.PROD = true;
_ß.THREAD = 'server';
_ß.CWD = '/srv/codepad-project';
_ß.THREAD_LOGGING_PREFIX = '-';
_ß.NAME = 'd250.hu';
_ß.GID = 804;
_ß.UID = 804;
_ß.BUILD_VERSION = '0.0.0';
_ß.VAR = '/srv/codepad-project/var';
_ß.BPLOG = '/srv/codepad-project/var/server.log';
_ß.EDITOR_SITELINK = 'https://d250.hu:9001';
_ß.HOSTNAME = 'd250.hu';
_ß.CFG = '/srv/codepad-project/config';
_ß.DATE = '2024-05-19';
_ß.TIME = '08:42:41';
_ß.MULTILANGUAGE_CHUNK_SEPERATOR = '';
_ß.MULTILANGUAGE_DEFAULT_LANG = 'en';
_ß.MULTILANGUAGE_LANGUAGE_PREFIX = '&';
_ß.APP_LANGUAGES = {"en":"English","hu":"Magyar"};
_ß.DEFAULT_LANG = 'en';
_ß.LOGLEVEL = 1;
_ß.MODULARITY_PROTOCOL_VERSION = 3;
_ß.USE_APP = true;
_ß.USE_GDPR = true;
_ß.USE_CORS = true;
_ß.USE_MULTILANGUAGE = true;
_ß.USE_FAVICON = true;
_ß.USE_NODEJS = true;
_ß.USE_FONTAWESOME5 = true;
_ß.USE_MONGODB = true;
_ß.USE_SERVER = true;
_ß.USE_VUE = true;
_ß.USE_VUE_CLI = true;
_ß.USE_SESSION = true;
_ß.USE_VUETIFY = true;
_ß.USE_VUEX = true;
_ß.THREADS = {"server":{"pid":102,"name":"server","cli":false,"modules":["app","gdpr","cors","multilanguage","favicon","nodejs","fontawesome5","mongodb","server","vue","vue_cli","session","vuetify","vuex"]}};
_ß.IMPORT_COMPONENT_ROUTES = true;
_ß.PAGES = {"en":{"entry":"src/main.js","template":"src/en.html","filename":"en.html","lang":"en"},"hu":{"entry":"src/main.js","template":"src/hu.html","filename":"hu.html","lang":"hu"}};
_ß.STATIC_OPTIONS = {"maxage":"24h"};
_ß.VAR_VUE = '/srv/codepad-project/var/vue';
_ß.VUE_INDEX_HTML = {"BODY":{},"HEAD":{}};
_ß.VUETIFY = {"icons":{"iconfont":"fa"}};
_ß.VUEX_FILES = {"server.js":"/srv/codepad-project/@vue-modules/vuex/vuex","socket.js":"/srv/codepad-project/@vue-modules/vuex/vuex"};
_ß.VUE_FILES = {"global-components/global-component.vue":"/srv/codepad-project/@vue-modules/app/vue","App.vue":"/srv/codepad-project/d250-modules/app/vue","app.functions.project.js":"/srv/codepad-project/@vue-modules/app/vue","app.main.dev.js":"/srv/codepad-project/@vue-modules/app/vue","app.router.base.js":"/srv/codepad-project/@vue-modules/app/vue","main.css":"/srv/codepad-project/d250-modules/app/vue","main.js":"/srv/codepad-project/d250-modules/app/vue","main.vue":"/srv/codepad-project/d250-modules/app/vue","navigation.vue":"/srv/codepad-project/d250-modules/app/vue","notification-snackbars.vue":"/srv/codepad-project/@vue-modules/app/vue","assets/tech_icons/ajax-color.svg":"/srv/codepad-project/d250-modules/app/vue","assets/tech_icons/angular-color.svg":"/srv/codepad-project/d250-modules/app/vue","assets/tech_icons/atom-color.svg":"/srv/codepad-project/d250-modules/app/vue","assets/tech_icons/bootstrap-color.svg":"/srv/codepad-project/d250-modules/app/vue","assets/tech_icons/codepen-color.svg":"/srv/codepad-project/d250-modules/app/vue","assets/tech_icons/css3-color.svg":"/srv/codepad-project/d250-modules/app/vue","assets/tech_icons/emmet-color.svg":"/srv/codepad-project/d250-modules/app/vue","assets/tech_icons/grunt-color.svg":"/srv/codepad-project/d250-modules/app/vue","assets/tech_icons/html5-color.svg":"/srv/codepad-project/d250-modules/app/vue","assets/tech_icons/laravel-color.svg":"/srv/codepad-project/d250-modules/app/vue","assets/tech_icons/nodejs-color.svg":"/srv/codepad-project/d250-modules/app/vue","assets/tech_icons/nodejs_white-color.svg":"/srv/codepad-project/d250-modules/app/vue","assets/tech_icons/php-color.svg":"/srv/codepad-project/d250-modules/app/vue","assets/tech_icons/react-color.svg":"/srv/codepad-project/d250-modules/app/vue","assets/tech_icons/sass-color.svg":"/srv/codepad-project/d250-modules/app/vue","assets/tech_icons/scotch-color.svg":"/srv/codepad-project/d250-modules/app/vue","assets/tech_icons/sublime-color.svg":"/srv/codepad-project/d250-modules/app/vue","assets/tech_icons/vagrant-color.svg":"/srv/codepad-project/d250-modules/app/vue","assets/tech_icons/vuejs-color.svg":"/srv/codepad-project/d250-modules/app/vue","assets/tech_icons/zurb-color.svg":"/srv/codepad-project/d250-modules/app/vue","assets/D250_Laboratories.svg":"/srv/codepad-project/d250-modules/app/vue","assets/bgLine.svg":"/srv/codepad-project/d250-modules/app/vue","assets/bg_purple.jpg":"/srv/codepad-project/d250-modules/app/vue","assets/bgtri.svg":"/srv/codepad-project/d250-modules/app/vue","assets/cloud.png":"/srv/codepad-project/d250-modules/app/vue","assets/cloud_d250.svg":"/srv/codepad-project/d250-modules/app/vue","assets/cube_d250.svg":"/srv/codepad-project/d250-modules/app/vue","assets/lapTop.png":"/srv/codepad-project/d250-modules/app/vue","assets/laptop_d250.svg":"/srv/codepad-project/d250-modules/app/vue","assets/login.jpg":"/srv/codepad-project/d250-modules/app/vue","assets/network.png":"/srv/codepad-project/d250-modules/app/vue","assets/server.png":"/srv/codepad-project/d250-modules/app/vue","assets/server_d250.svg":"/srv/codepad-project/d250-modules/app/vue","assets/ve_1.svg":"/srv/codepad-project/d250-modules/app/vue","assets/ve_black.svg":"/srv/codepad-project/d250-modules/app/vue","assets/ve_white.svg":"/srv/codepad-project/d250-modules/app/vue","bg_slide.vue":"/srv/codepad-project/d250-modules/app/vue","contact.vue":"/srv/codepad-project/d250-modules/app/vue","en.html":"/srv/codepad-project/d250-modules/app/vue","home.vue":"/srv/codepad-project/d250-modules/app/vue","home_footer.vue":"/srv/codepad-project/d250-modules/app/vue","home_services.vue":"/srv/codepad-project/d250-modules/app/vue","home_top.vue":"/srv/codepad-project/d250-modules/app/vue","home_ve_layout.vue":"/srv/codepad-project/d250-modules/app/vue","hu.html":"/srv/codepad-project/d250-modules/app/vue","index.html":"/srv/codepad-project/d250-modules/app/vue","page_administration.vue":"/srv/codepad-project/d250-modules/app/vue","page_cloudhosting.vue":"/srv/codepad-project/d250-modules/app/vue","page_development.vue":"/srv/codepad-project/d250-modules/app/vue","page_infrastructure.vue":"/srv/codepad-project/d250-modules/app/vue","page_ve-farm.vue":"/srv/codepad-project/d250-modules/app/vue","multilanguage-components/LanguageSelector.vue":"/srv/codepad-project/@vue-modules/multilanguage/vue","app.main.fontawesome.js":"/srv/codepad-project/@vue-modules/fontawesome5/vue","functions.mjs":"/srv/codepad-project/@vue-modules/vue/vue","main.mjs":"/srv/codepad-project/@vue-modules/vue/vue","router.mjs":"/srv/codepad-project/@vue-modules/vue/vue","builder.txt":"/srv/codepad-project/@vue-modules/vue_cli/vue","plugins/vuetify.js":"/srv/codepad-project/@vue-modules/vuetify/vue","app.main.vuetify.js":"/srv/codepad-project/@vue-modules/vuetify/vue","vuetify-options.mjs":"/srv/codepad-project/@vue-modules/vuetify/vue"};
_ß.FORK_VUE_BUILD = true;
_ß.FORK_VUE_SERVE = false;
import getRegexDate from '/srv/codepad-project/@vue-modules/app/logic/getRegexDate.mjs';

_ß.logic.getRegexDate = getRegexDate;

_ß.getRegexDate = getRegexDate;

import getRegexEmail from '/srv/codepad-project/@vue-modules/app/logic/getRegexEmail.mjs';

_ß.logic.getRegexEmail = getRegexEmail;

_ß.getRegexEmail = getRegexEmail;

import getRegexHuBankAccountNumber from '/srv/codepad-project/@vue-modules/app/logic/getRegexHuBankAccountNumber.mjs';

_ß.logic.getRegexHuBankAccountNumber = getRegexHuBankAccountNumber;

_ß.getRegexHuBankAccountNumber = getRegexHuBankAccountNumber;

import getRegexHuCompanyRegistrationNumber from '/srv/codepad-project/@vue-modules/app/logic/getRegexHuCompanyRegistrationNumber.mjs';

_ß.logic.getRegexHuCompanyRegistrationNumber = getRegexHuCompanyRegistrationNumber;

_ß.getRegexHuCompanyRegistrationNumber = getRegexHuCompanyRegistrationNumber;

import getRegexHuPhone from '/srv/codepad-project/@vue-modules/app/logic/getRegexHuPhone.mjs';

_ß.logic.getRegexHuPhone = getRegexHuPhone;

_ß.getRegexHuPhone = getRegexHuPhone;

import getRegexHuTax from '/srv/codepad-project/@vue-modules/app/logic/getRegexHuTax.mjs';

_ß.logic.getRegexHuTax = getRegexHuTax;

_ß.getRegexHuTax = getRegexHuTax;

import getRegexHuZip from '/srv/codepad-project/@vue-modules/app/logic/getRegexHuZip.mjs';

_ß.logic.getRegexHuZip = getRegexHuZip;

_ß.getRegexHuZip = getRegexHuZip;

import getRegexIBAN from '/srv/codepad-project/@vue-modules/app/logic/getRegexIBAN.mjs';

_ß.logic.getRegexIBAN = getRegexIBAN;

_ß.getRegexIBAN = getRegexIBAN;

import getRegexPhone from '/srv/codepad-project/@vue-modules/app/logic/getRegexPhone.mjs';

_ß.logic.getRegexPhone = getRegexPhone;

_ß.getRegexPhone = getRegexPhone;

export default Object.freeze(_ß);